import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable, forkJoin } from 'rxjs';
import {
  VehicleTypeApiModel,
  VehicleTypeModel,
} from '../models/vehicle-types-api.model';
import { MwPayloadModel } from 'app/models/payload.model';

@Injectable({ providedIn: 'root' })
export class MwVehicleTypesApiService {
  constructor(private http: MwHttpService) {}

  getVehicleTypes(): Observable<MwPayloadModel<VehicleTypeApiModel[]>> {
    return this.http.authGet<MwPayloadModel<VehicleTypeApiModel[]>>(
      `/integration/v1/Companies/{companyId}/VehicleTypes?$inlinecount=allpages`
    );
  }

  createVehicleType(
    vehicleType: VehicleTypeModel
  ): Observable<VehicleTypeModel> {
    return this.http.authPost<VehicleTypeModel>(
      `/integration/v1/Companies/{companyId}/VehicleTypes`,
      {
        body: vehicleType,
      }
    );
  }

  updateVehicleType(
    vehicleType: VehicleTypeModel
  ): Observable<VehicleTypeModel> {
    return this.http.authPut<VehicleTypeModel>(
      `/integration/v1/Companies/{companyId}/VehicleTypes`,
      {
        body: vehicleType,
      }
    );
  }

  deleteVehicleType(vehicleType: VehicleTypeModel): Observable<any> {
    return this.http.authDelete<VehicleTypeModel>(
      `/integration/v1/Companies/{companyId}/VehicleTypes`,
      {
        body: vehicleType,
      }
    );
  }

  deleteVehicleTypesList(vehicleTypes: VehicleTypeModel[]): Observable<any> {
    return this.http.authDelete<any>(
      `/integration/v1/Companies/{companyId}/VehicleTypes/All`,
      { body: vehicleTypes }
    );
  }
}
